module.exports = __webpack_public_path__ + "cb8f8103aaf62678fd74595af3ccd710.png";